module.exports = __webpack_public_path__ + "img/shopdeal-01.35aafb1e.png";